import { styled } from '@linaria/react';
import { css } from '@linaria/core';
import { m } from 'framer-motion';
import { COLORS } from '@livecommerce/design-system';
import { LEFT_GAP, SIDEBAR_WIDTH } from '../ProductsNavigation/constants.js';
import ProductSwitcher from 'components-v3/ProductSwitcher/index.jsx';
import SkeletonCell from 'components-v3/List/cells/SkeletonCell.jsx';
import { TextWrapper } from '../ProductSwitcher/styles.js';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const logoStyles = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 64px;
  width: 96px;
  flex-shrink: 0;
  pointer-events: none;
  margin-right: 16px;
`;

export const ProductSwitcherContainer = styled(m.div)`
  display: flex;
  align-items: center;
  margin-right: 16px;

  ${TextWrapper} {
    min-width: auto;
  }
`;

export const ProductStatsContainer = styled(m.div)`
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
`;

export const ProductHeaderCollapsed = styled.div`
  display: flex;
  align-items: center;
`;

export const ProductMenu = styled(m.div)`
  margin-left: ${LEFT_GAP + SIDEBAR_WIDTH}px;
  padding: 24px 40px 48px 16px;
  color: ${COLORS.white};
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const OrgSelectorAndGLobalProductSwitcherRow = styled(m.div)`
  display: flex;
  align-items: flex-end;
  gap: 24px;
  justify-content: space-between;
`;

export const OrgListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 280px;
`;

export const SkeletonListWrapper = styled(m.div)`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const GroupsWrapper = styled(m.div)`
  display: flex;
  gap: 24px;
`;

export const CustomProductSwitcher = styled(ProductSwitcher)`
  min-width: 326px;
  background-color: ${COLORS.dark_600};
`;

export const SkeletonWrapper = styled.div`
  display: grid;
  grid-template-columns: 44px 1fr;
  gap: 8px;
  min-width: 326px;
  min-height: 61px;
  align-items: center;
`;

export const SkeletonColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  max-width: 146px;
`;

export const StyledSkeletonCell = styled(SkeletonCell)`
  min-height: 12px;
`;

export const StyledWorkspaceLogoImg = styled.img`
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  display: block;
  margin: 0 auto;
  padding: 6%;
`;

export const SwitchersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SwitchersList = styled.ul`
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  gap: 8px;
  flex-wrap: wrap;
`;

export const SwitchersListItem = styled.li``;

export const productLabelStyles = css`
  color: ${COLORS.light_600};
`;
